import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Client } from 'src/app/clients-module/models/clientLocation';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { SearchPackage, SearchRecord } from '../models/searchPackage';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { ClientPackagePricing, SearchRecordClientPricing } from '../models/clientPackagePrice';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-client-package-edit',
  templateUrl: './client-package-edit.component.html',
  styleUrls: ['./client-package-edit.component.less']
})
export class ClientPackageEditComponent implements OnInit {

  @Input() clientId: number;
  @Input() packageId: number
  clientToUse: Client;
  clientPricingModel : ClientPackagePricing;
  public packageToEdit: SearchPackage;
  public packageLoaded: boolean = false;
  constructor(private modalService: NgbModal,
    public clients: ClientService,
    public toasts : ToastrService,
    public packages: SearchPackageService) { 
      this.clientPricingModel = new ClientPackagePricing();
      
    }

  ngOnInit() {
    this.clients.GetClientById(this.clientId).subscribe((scc: Client) => {
      this.clientToUse = scc;
    });

    this.packages.FetchSearchPackageById(this.packageId).subscribe((pkg: Array<SearchPackage>) => {
      this.packageToEdit = Object.assign(new SearchPackage(), pkg[0]);
      this.packageToEdit.searches = this.packageToEdit.searches.map(s => {
        return Object.assign(new SearchRecord(), s);
      })

      // Then see if we can find an existing override for this client/package
      this.packages.GetClientSearchPackageOverride(this.clientId,this.packageToEdit.id).subscribe((scc: ClientPackagePricing)=>{
        if(scc != null){
          this.clientPricingModel = scc

          this.packageToEdit.searches.forEach(element => {
            let discoveredOverride = this.clientPricingModel.searchOverrides.find(so =>{return so.searchRecordId == element.id});
            if(discoveredOverride){
              element.cost = discoveredOverride.clientSearchCost
            }
          });
         }
        else{
          this.clientPricingModel.clientPackageCost = this.packageToEdit.cost;
          this.clientPricingModel.clientId = this.clientId;
          this.clientPricingModel.searchPackageId = this.packageId;  
        }
        this.packageLoaded = true;
      })
    
    })
  }

  toggleIncomeVer(){
    console.log('toggle income ver');
    this.clientPricingModel.enableIncomeVerification = !this.clientPricingModel.enableIncomeVerification;
    console.log('toggle income ver outcome', this.clientPricingModel.enableIncomeVerification);

  }

  save(){
    if(this.clientPricingModel.id == 0){
      this.packages.SaveClientSearchPackageOverride(this.clientPricingModel).subscribe((scc: ClientPackagePricing)=>{
        if(scc){
            this.clientPricingModel = scc;
            this.toasts.success('','Package Overrides Saved Successfully');
            this.modalService.dismissAll();
          }
        else
          this.toasts.error(`There was an error saving your package overrides for ${this.clientToUse.clientName}, please contact Development for support`, 'Error Saving Package Overrides');
  
      }, (err: any)=>{
        this.toasts.error(`There was an error saving your package overrides for ${this.clientToUse.clientName}, please contact Development for support`, 'Error Saving Package Overrides');
      })
    }else{
      console.log('Updating client package overrides', this.clientPricingModel)
      this.packages.UpdateClientSearchPackageOverride(this.clientPricingModel).subscribe((scc:ClientPackagePricing)=>{
        if(scc)
          this.clientPricingModel = scc;
        this.toasts.success(`Your package overrides for ${this.clientToUse.clientName} Saved.`,'Update Successful');
        this.modalService.dismissAll();
      }, (err: any)=>{
        this.toasts.error(`There was an error updating your package overrides for ${this.clientToUse.clientName}, please contact Development for support`, 'Error Updating Package Overrides');
      })
    }
    
  }

  update(evt: SearchRecord){
    let existingOverride = this.clientPricingModel.searchOverrides.find(so =>{return so.searchRecordId == evt.id; });
    if(existingOverride){
      existingOverride.clientSearchCost = evt.cost;
    }else{
      let override = new SearchRecordClientPricing();
      override.clientId = this.clientId;
      override.clientSearchCost = evt.cost;
      override.searchPackageId = this.packageId;
      override.searchRecordId = evt.id;
      this.clientPricingModel.searchOverrides.push(override);
    }
  }

}
